var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleSlides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242424 333334",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 200291,
    y1: 94137,
    x2: 200291,
    y2: 173145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf360c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 200291,
    y1: 91174.4,
    x2: 200291,
    y2: 176107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M158007 84111h84568v99059h-84568z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151516 0H22726C10228 0 0 10228 0 22726v287880c0 12494 10228 22728 22726 22728h196971c12494 0 22728-10234 22728-22728V90909l-53037-37880L151516 1z",
    fill: "#f4b300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170452 151515H71970c-6252 0-11363 5113-11363 11363v98483c0 6251 5112 11363 11363 11363h98482c6252 0 11363-5112 11363-11363v-98483c0-6250-5111-11363-11363-11363zm-3792 87118H75756v-53027h90904v53027z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#b)",
    fill: "url(#c)",
    d: "M158158 84261l84266 84242V90909z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151516 0v68181c0 12557 10167 22728 22726 22728h68182L151515 0z",
    fill: "#f9da80"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.102,
    d: "M151516 0v1893l89008 89016h1900z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22726 0C10228 0 0 10228 0 22726v1893C0 12121 10228 1893 22726 1893h128790V0H22726z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219697 331433H22726C10228 331433 0 321209 0 308705v1900c0 12494 10228 22728 22726 22728h196971c12494 0 22728-10234 22728-22728v-1900c0 12504-10233 22728-22728 22728z",
    fill: "#bf360c",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174243 90909c-12559 0-22726-10171-22726-22728v1893c0 12557 10167 22728 22726 22728h68182v-1893h-68182z",
    fill: "#bf360c",
    fillOpacity: 0.102
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSlides);
export default __webpack_public_path__ + "static/media/google-slides.933e2f33355c24007649dc018ffff938.svg";
export { ForwardRef as ReactComponent };